jQuery(function($) {
  var body = $('body');

  var activeMTSS = function() {
    body.addClass('mtss-active');
  }
  var activeRestorativePractices = function() {
    body.addClass('restorative-practices-active');
  }
  var activeBudgeting = function() {
    body.addClass('budgeting-active');
  }
  var activeOrgCharts = function() {
    body.addClass('org-charts-active');
  }
  var activeCleveland = function() {
    body.addClass('cleveland-active');
  }

  var toggleResults = function() {
    var param = getParameterByName('search');
    if (param == 'MTSS') {
      activeMTSS();
    } else if(param == 'Restorative Practices') {
      activeRestorativePractices();
    } else if(param == 'Budgeting') {
      activeBudgeting();
    } else if(param == 'Organizational Charts') {
      activeOrgCharts();
    } else if(param == 'Cleveland') {
      activeCleveland();
    } else {

    }
  }

  function getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  $(window).on('load', toggleResults);

});
